import axiosInstance from "../utilities/axiosSetup";

export const list_all_languages = async () => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/list-all-languages",
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};
export const sync_users = async () => {
  try {
    const { data } = await axiosInstance.post(
      import.meta.env.VITE_API_URL + "/insert-users",
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};